import Vue from 'vue'
import { mapState } from 'vuex'
import DashboardEntitiesView from '@/screens/dashboard/components/dashboard-entities-view.vue'
import DashboardEntitiesLoading from '@/screens/dashboard/components/dashboard-entities-loading.vue'
import { IProfileState } from '@/modules/profile/profile.types'

export default Vue.extend({
  components: {
    DashboardEntitiesView,
    DashboardEntitiesLoading,
  },

  computed: {
    ...mapState('profile', {
      profile: (state: IProfileState) => state.data,
    }),
  },
})
